import { render, staticRenderFns } from "./Negociation.vue?vue&type=template&id=922db452&scoped=true"
import script from "./Negociation.vue?vue&type=script&lang=js"
export * from "./Negociation.vue?vue&type=script&lang=js"
import style0 from "./Negociation.vue?vue&type=style&index=0&id=922db452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922db452",
  null
  
)

export default component.exports